import { path } from '@antv/x6/lib/registry/marker/path';

interface IRouteConfig {
  path: string;
}
type RouteConfig =
  | IRouteConfig
  | {
      [x: string]: any;
    };
// 算法中心
export const algorithmCenter: RouteConfig = {
  path: '/algorithmCenter'
};
export const anchor: RouteConfig = {
  path: '/anchor'
};
export const algorithmCenterModelDetail = {
  content: {
    add: '/algorithmCenter/list/contentDetail',
    edit: `/algorithmCenter/list/editContentDetail/:modelId/:operationType?`,
    copy: `/algorithmCenter/list/copyContentDetail/:modelId/:operationType?`
  },
  expression: {
    add: '/algorithmCenter/list/expressionDetail',
    edit: '/algorithmCenter/list/editExpressionDetail/:modelId/:operationType?',
    copy: '/algorithmCenter/list/copyExpressionDetail/:modelId/:operationType?'
  },
  customize: {
    add: '/algorithmCenter/list/customizeDetail',
    edit: `/algorithmCenter/list/editCustomizeDetail/:modelId/:operationType?`,
    copy: `/algorithmCenter/list/copyCustomizeDetail/:modelId/:operationType?`
  }
};
// 反馈管理
export const feedback = {
  path: '/feedback'
};
export const feedbackDetail = {
  path: '/feedback/:id'
};
export const questionCenter: RouteConfig = {
  path: '/questionCenter'
};
export const questionCenterDetail = {
  create: '/questionCenter/new',
  update: `/questionCenter/edit/:id?/:type?`,
  copy: '/questionCenter/copy/:id?/:type?'
};
export const group = {
  path: '/identity/:identityId/group'
};
export const groupDetail = {
  path: '/identity/:identityId/group/:groupId'
};

// 数据仪表盘，个人能力报告
export const dashboardMemberConfig = {
  memberDetail: `/v2_dashboard/member/:userId`,
  memberPracticeDetail: `/v2_dashboard/member/:userId/groups`,
  memberSituationDetail: `/v2_dashboard/member/:userId/groups/:groupId/unit/:unitId`,
  customMemberSituationDetail: `/v2_dashboard/member/custom/:userId/groups/:groupId/unit/:unitId`
};

//  陪练组/陪练单元
export const unit = {
  //  高级陪练单元--环节管理
  advanced: '/identity/:identityId/group/:groupId/unit/:unitId',
  //  高级陪练单元--配置报告
  reportSetting: '/identity/:identityId/group/:groupId/unit/:unitId/reportSetting',
  // 陪练单元-互评卷-列表
  assessQuestionnaireList: '/identity/:identityId/group/:groupId/unit/:unitId/assessQuestionnaire',
  // 陪练单元-互评卷-新增
  assessQuestionnaireCreate:
    '/identity/:identityId/group/:groupId/unit/:unitId/assessQuestionnaire/:assessId/create',
  // 陪练单元-互评卷-更新
  assessQuestionnaireUpdate:
    '/identity/:identityId/group/:groupId/unit/:unitId/assessQuestionnaire/:assessId/update',
  // 陪练单元-人工评分-列表
  manualScoringList: '/identity/:identityId/group/:groupId/unit/:unitId/manualScoring',
  // 陪练单元-互评卷-新增
  manualScoringCreate:
    '/identity/:identityId/group/:groupId/unit/:unitId/manualScoring/:assessId/create',
  // 陪练单元-互评卷-更新
  manualScoringUpdate:
    '/identity/:identityId/group/:groupId/unit/:unitId/manualScoring/:assessId/update'
};

export const testPaper = {
  path: '/testPaper',
  create: '/identity/:identityId/group/:groupId/unit/:unitId/new',
  update: '/identity/:identityId/group/:groupId/unit/:unitId/edit/:id?'
};

//  模板管理
export const tplManage = {
  listPath: `/tpl`,
  createPath: `/tpl/create`,
  editPath: `/tpl/edit/:id`
};

//  练习记录
export const practiceDataManage = {
  listPath: `/practice-record`,
  detailPath: `/practice-record/:id`
};

// 考试记录
export const examRecordManage = {
  listPath: `/exam-record`,
  detailPath: `/exam-record/:id`
};

// 项目管理
export const projectManage = {
  path: '/project'
};
// 项目编辑
export const projectManageEdit = {
  path: '/project/:projectId'
};
// 能力评价管理
export const evaluatePracticeProjectAbility = {
  path: '/project/:identityId/evaluate-practice-project-ability'
};
// 学习小组配置
export const studyGroupManage = {
  path: `/project/:identityId/study-group-manage`
};
// 场景管理
export const situationManage = {
  path: '/project/:identityId/situation'
};
// 情境管理
export const scenesManage = {
  path: '/project/:identityId/situation/:groupId'
};
// 考试卷管理
export const examConfiguration = {
  path: '/project/:identityId/situation/0/exam/:examId',
  config: '/project/:identityId/situation/0/exam/:examId/round/:roundId',
  updateQuestion:
    '/project/:identityId/situation/0/exam/:examId/round/:roundId/question/:questionId',
  examPaperList: '/project/:identityId/situation/0/examPaper/:examId',
  examPaperDetail: '/project/:identityId/situation/0/examPaper/:examId/paper/:examPaperId'
};
// 快速配卷
export const quickConfiguration = {
  path: '/project/:identityId/situation/:groupId/quickConfiguration',
  update: '/project/:identityId/situation/:groupId/quickConfiguration/:sceneId'
};
// 题组管理
export const questionGroupManage = {
  path: '/project/:identityId/situation/:groupId/scenes/:unitId'
};
// 题组配置
export const questionGroupConfig = {
  create: '/project/:identityId/situation/:groupId/scenes/:unitId/round/create',
  path: '/project/:identityId/situation/:groupId/scenes/:unitId/round/:roundId',
  graphPath: '/project/:identityId/situation/:groupId/scenes/:unitId/roundgraph/:roundId'
};
// 题目配置
export const questionConfigUnderGroup = {
  path: '/project/:identityId/situation/:groupId/scenes/:unitId/round/:roundId/question/create',
  update:
    '/project/:identityId/situation/:groupId/scenes/:unitId/round/:roundId/question/:questionId'
};

// 异常监控配置
export const cheatconfig = {
  practicePath: `/project/:identityId/situation/:groupId/scenes/:unitId/cheatconfig/:businessId/:type`,
  examPath: `/project/:identityId/situation/cheatconfig/:businessId/:type`
};

// 考试闯关
export const examGroupConfig = {
  path: `/project/:identityId/situation/exam/examgroupconfig`
};
// 评语配置
export const groupAndUnitComment = {
  path: '/project/:identityId/situation/comments/:groupId'
};

/** 数据看板 */
export const projectDashboard = {
  path: '/projectDashboard/:identityId'
};
/** AZ定制看板 */
export const projectCustomForAZ = {
  path: '/projectCustomForAZ/:identityId',
  /** 对应案例 */
  case: '/projectCustomForAZ/:identityId/case/:dashboardId'
};

// 内容管理
export const contentManagement = {
  path: '/learn/content/list',
  contentCreate: '/learn/content/list/new',
  contentUpdate: '/learn/content/list/:id',
  contentCopy: '/learn/content/list/copy/:id',
  journeyPath: '/learn/journey/list',
  studyJourneyCreate: '/learn/journey/list/new',
  studyJourneyUpdate: '/learn/journey/list/:id'
};

export const noAuthConfig = {
  path: '/noAuth'
};

export const organizationConfig = {
  path: '/organization',
  studentPath: '/organization/student',
  teacherPath: '/organization/teacher',
  recycleBin: '/organization/:type/recycleBin'
};

export const abilityModalReportConfig = {
  path: '/abilityModalReportConfig',
  editPath: '/abilityModalReportConfigEdit/:id?'
};

/** 通知推送管理路由 */
export const notificationManage = {
  path: '/project/:identityId/notification',
  create: '/project/:identityId/notification/new',
  update: '/project/:identityId/notification/edit/:id',
  record: '/project/:identityId/notification/:id/record'
};

/** AI题库路由 */
export const aiQuestionBank = {
  path: '/systemset/ai-question-bank'
};

/** AI题目路由 */
export const aiQuestion = {
  path: '/systemset/ai-question-bank/:questionBankId/question'
};

/** AI题库 题目列表 题目新建、编辑 路由 */
export const aiQuestionEdit = {
  create: '/systemset/ai-question-bank/:questionBankId/question/new',
  update: '/systemset/ai-question-bank/:questionBankId/question/edit/:id'
};

/** 角色管理 */
export const authority = {
  role: '/authority/role',
  createRole: '/authority/roleDetail',
  updateRole: '/authority/roleEditDetail/:roleId/:roleType',
  account: '/authority/user'
};
